import type { FC } from "react";
import Text from "../Text";
import { getColorKrunshScore } from "@/lib/utils";

type Props = {
  value: number;
};

const KrunshScore: FC<Props> = ({ value }) => (
  <div
    className="bg-[white] h-[40px] min-h-[40px] w-[40px] min-w-[40px] rounded-[50%] flex items-center justify-center"
    style={{ border: `solid 2px ${getColorKrunshScore(value)}` }}
  >
    <Text fontWeight={600} fontSize={14} color={getColorKrunshScore(value)}>
      {value}
    </Text>
  </div>
);

export default KrunshScore;
